module.exports = __webpack_public_path__ + "img/newpartner4.2f515203.png";